/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkPackagePriorityRequest } from '../../models/create-work-package-priority-request';
import { WorkPackagePriorityDto } from '../../models/work-package-priority-dto';

export interface CreateWorkPackagePriority$Params {
      body: CreateWorkPackagePriorityRequest
}

export function createWorkPackagePriority(http: HttpClient, rootUrl: string, params: CreateWorkPackagePriority$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDto>> {
  const rb = new RequestBuilder(rootUrl, createWorkPackagePriority.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackagePriorityDto>;
    })
  );
}

createWorkPackagePriority.PATH = '/v0/workPackagePriorities/{id}';
